import { useMutation, useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

const MANAGE_API_TOKEN_LIMITS_KEY = 'manage-api-token-limits'

type ApiTokenLimitsRequest = {
  appUserId: string
  orgId?: string
}

type APITokenLimitResponse = {
  id: string
  ownerId: string
  allowance: number
  allowanceRate: number
  usage: number
  lastUsage: string | null
  hardLimit: number
  softLimit: number
}

type ApiTokenUpdateLimitsRequestPayload = {
  appUserId: string
  orgId: string
  allowance: number
  allowanceRate: number
  hardLimit: number
  softLimit: number
}

type ApiTokenResetUsageRequestPayload = {
  appUserId: string
  orgId: string
}

export function useGetLimits({ hasTokens, ...params }: ApiTokenLimitsRequest & { hasTokens: boolean }) {
  return useQuery({
    queryKey: [MANAGE_API_TOKEN_LIMITS_KEY, params],
    queryFn: async () => {
      const { data } = await apiClient.get<APITokenLimitResponse>('/int/v3/api-limit', { params })
      return data
    },
    refetchOnWindowFocus: false,
    enabled: !!params.orgId && hasTokens,
  })
}

export function useUpdateLimits() {
  return useMutation({
    mutationFn: async (payload: ApiTokenUpdateLimitsRequestPayload) => {
      const { data } = await apiClient.put<APITokenLimitResponse>('/int/v3/api-limit', payload)
      return data
    },
  })
}

export function useResetUsage() {
  return useMutation({
    mutationFn: async (payload: ApiTokenResetUsageRequestPayload) => {
      const { data } = await apiClient.put('/int/v3/api-limit/reset', undefined, { params: payload })
      return data
    },
  })
}
